export enum QuestionDomainEnum {
  Null = 'null',
  Knowledge = 'Knowledge',
  Attitude = 'Attitude',
  Behavioral = 'Behavioral',
  General = 'General',
  SelfAssessment = 'SelfAssessment',
  OtherAssessment = 'OtherAssessment',
}
